module.exports = __webpack_public_path__ + "images/emoji/grey_question.b53f477e3d41e430d8cc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/grey_question.png
// module id = d7HM
// module chunks = 2